import React from "react";
import "./AISolutions.css";
import SEO from "../../SEO";
const aiServices = [
  {
    title: "Generative AI & LLMs",
    description:
      "Custom AI chatbots and content generation tools trained on your business data to automate customer support and internal workflows.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmq3NYvfA7P7gQK80aQKNgagM9A7qJOQ3QQA&s",
    icon: "bi-cpu-fill",
    features: [
      "Scalable Infrastructure",
      "Data Privacy Guaranteed",
      "Seamless ERP Integration",
    ],
  },
  {
    title: "Predictive Analytics",
    description:
      "Analyze historical data to forecast sales trends, inventory demands, and customer behavior with high accuracy.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8i2KKVCS8p8ai5pus6ylZgn5nBIPPF1olDA&s",
    icon: "bi-graph-up-arrow",
    features: [
      "Scalable Infrastructure",
      "Data Privacy Guaranteed",
      "Seamless ERP Integration",
    ],
  },
  {
    title: "Computer Vision",
    description:
      "Visual AI for quality control in manufacturing, face recognition for security, and automated document processing.",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRfY_KdUZF-Z1mY2z4smOs0qSsZ07lLVj2Ug&s",
    icon: "bi-eye-fill",
    features: [
      "Scalable Infrastructure",
      "Data Privacy Guaranteed",
      "Seamless ERP Integration",
    ],
  },
  {
    title: "Business Process Automation",
    description:
      "AI-driven RPA (Robotic Process Automation) to handle repetitive tasks like invoice processing and data entry.",
    img: "https://www.vertexplus.com/vertexplusadmin/uploads/blogs/main_image_166_1696592269.jpg",
    icon: "bi-gear-wide-connected",
    features: [
      "Scalable Infrastructure",
      "Data Privacy Guaranteed",
      "Seamless ERP Integration",
    ],
  },
];

function AISolutions() {
  return (
    <>
      <SEO
        title="AI Solutions – MZR Software"
        description="Leverage artificial intelligence solutions for your business with MZR Software’s AI services."
        image="https://mzrsoftware.com/assets/images/og-aisolutions.jpg"
        url="https://mzrsoftware.com/OurServices/AISolutions/aisolutions"
      />

      <div className="ai-solutions-page">
        {/* Hero Section */}
        <section className="ai-hero text-center">
          <div className="container">
            <h1 className="display-4 fw-bold text-white mb-3">
              MZR <span className="highlight">AI Intelligence</span>
            </h1>
            <p className="lead text-white mb-4">
              Empowering your business with next-gen Artificial Intelligence
              solutions.
            </p>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <div className="container">
            <div className="services-grid">
              {aiServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${index % 2 === 0 ? "left" : "right"}`}
                >
                  <div className="card-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="card-image">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="img-fluid rounded-4 shadow-lg"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AISolutions;
